import { BookOpenIcon, ZapIcon, type LucideIcon } from 'lucide-react';

export interface Pillar {
  icon: LucideIcon;
  tag: string;
  title: string;
  value: string;
  today: string;
  lead: string;
  items: string[];
}

export const pillars: Pillar[] = [
  {
    icon: BookOpenIcon,
    tag: 'Incluido 📚',
    title: 'Los 6 Tomos del Sistema "Mira y Pita"',
    value: '79,90€',
    today: 'Hoy: Incluido',
    lead: 'Sesiones listas y profesionales para que nunca te falten ejercicios.',
    items: [
      'TOMO 1 — Cimientos (1º-3º Primaria): Psicomotricidad, esquema corporal, habilidades básicas, juego cooperativo. Sesiones listas. Ideal para edades donde todo es nuevo y la diversión es lo primero.',
      'TOMO 2 — Despegue (4º-6º Primaria): Iniciación deportiva, expresión corporal, transición a deporte real. Sesiones listas. El momento donde aparecen los roles y la estrategia comienza.',
      'TOMO 3 — Transición (1º-2º ESO): Autonomía inicial, tácticas básicas, liderazgo emergente. Sesiones listas. Los adolescentes necesitan sentido y propósito. Esto lo da.',
      'TOMO 4 — Desafío (3º-4º ESO): Especialización, mentoría de pares, proyecto vital. Sesiones listas. Aquí preguntan "¿para qué?" y tú tienes respuesta clara.',
      'TOMO 5 — Alto Rendimiento (Bachillerato): Fisiología aplicada, entrenamiento periodizado, carrera profesional. Sesiones listas. Para los que quieren ir más allá.',
      'TOMO 6 — El Comodín (Emergencia): Lluvia, patio ocupado, sin material, mezcla de edades. Sesiones listas. Tu salvavidas cuando todo falla.'
    ]
  },
  {
    icon: ZapIcon,
    tag: 'Incluido 💪',
    title: 'Los 6 Bonos Estratégicos',
    value: '89,70€',
    today: 'Hoy: Incluido',
    lead: 'Los recursos que hacen que el sistema funcione desde el primer día.',
    items: [
      'Bono #1 — Mapa Flash de Arranque 7 Días: Diagnóstico rápido y primera sesión lista para empezar sin agobios.',
      'Bono #2 — Chuleta LOMLOE de Patio: Frases copiables para justificar cada sesión en lenguaje curricular.',
      'Bono #3 — Kit Visual "Mira y Pita": Fichas visuales listas para consultar en el patio en 10 segundos.',
      'Bono #4 — Scripts de Explicación en 15 Segundos: Frases exactas para explicar sin perder la atención del grupo.',
      'Bono #5 — Panel Anticaos del Profe de EF: Señales, normas y rutinas para controlar la clase sin gritar.',
      'Bono #6 — Tracker Flash de Progreso y Evidencias: Registra evaluación en segundos con datos que defienden tu nota.'
    ]
  }
];
